import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'

export function BackButton({children, ...props}) {
  return (
    <AtomButton
      color={atomButtonColors.PRIMARY}
      design={atomButtonDesigns.LINK}
      fullWidth
      shape={atomButtonShapes.CIRCULAR}
      size={atomButtonSizes.LARGE}
      {...props}
    >
      {children}
    </AtomButton>
  )
}

BackButton.displayName = 'StepperFlowBackButton'
BackButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
}
